import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DoeActions } from '../constants/ActionTypes';
import { Assessment } from '../pages/Doe/interfaces';

export type JobData = Pick<
  Assessment,
  | 'id'
  | 'tradeCategory'
  | 'tradeSubCategory'
  | 'suburb'
  | 'postcode'
  | 'recommendedWork'
  | 'estCost'
  | 'amuEstimated'
>;

interface DoeState {
  jobData: JobData;
}

export const doe = createSlice({
  name: 'DOE',
  initialState: {
    jobData: {},
  } as DoeState,
  reducers: {
    [DoeActions.DOE_POST_JOB]: (state, action: PayloadAction<JobData>) => ({
      ...state,
      jobData: action.payload,
    }),
  },
});
